import React from 'react';
import Users from '@/containers/User';
import { Route, Switch } from 'react-router-dom';
import Organizations from '@/containers/Organization';
import Subscriptions from '@/containers/Subscription';

export default () => (
  <Switch>
    <Route path="/workspace/users" component={Users} />
    <Route path="/workspace/organizations" component={Organizations} />
    <Route path="/workspace/subscriptions" component={Subscriptions} />
  </Switch>
);
